const Showroom = () => {
    return (
        <video class="center-block" src="video1.mp4" style={{height:'80%', width:'100%'}} autoplay controls loop muted >
        Lo sentimos. Este vídeo no puede ser reproducido en tu navegador.<br />
        La versión descargable está disponible en <a href="URL">Enlace</a>. 
        </video>
    )
}

export default Showroom;